import Config from "../../Configs";

export default class LogService {
  init(): void {
    // SentryService.init();
    if (!Config.isDebug) {
      // eslint-disable-next-line no-empty-function
      //
    }
  }
  logError(error: any): void {
    // console.log(error);
    // SentryService.logError(error);
  }
}
